<template>
  <centered-layout :showFooter="true">
    <status :stepStatuses="stepStatuses" @click="logout">
      <heading level="2" class="title" slot="title">{{ $t('confirmationDocs.title') }}</heading>
      <div class="description" slot="description">{{ $t('confirmationDocs.description') }}</div>
      <span slot="buttonLabel">{{ $t('confirmationDocs.button') }}</span>
    </status>
  </centered-layout>
</template>

<script>
import Status from '@/components/Status';
import CenteredLayout from '@/views/layouts/CenteredLayout';
import { COMPLETE } from '@/constants/application-step-statuses';

export default {
  components: {
    CenteredLayout,
    Status,
  },
  data() {
    return {
      stepStatuses: [COMPLETE, COMPLETE, undefined],
    };
  },
  methods: {
    async logout() {
      await this.$auth.logOut(this.$env.VUE_APP_LOGOUT);
    },
  },
};
</script>
<style lang="sass" scoped></style>
